import React, { Component } from "react";
import ProjAdminItemsListV2 from "./ProjAdminItemsListV2";

class ProjAdminItems extends Component {
  render() {
    const { tabId, permissions, projectId, isReadOnly } = this.props;
    return (
      <React.Fragment>
        <ProjAdminItemsListV2
          tabId={tabId}
          projectId={projectId}
          permissions={permissions}
          isReadOnly={isReadOnly}
        />
      </React.Fragment>
    );
  }
}

export default ProjAdminItems;
